import { render, staticRenderFns } from "./partner-table.vue?vue&type=template&id=f0cb3c8c&"
import script from "./partner-table.vue?vue&type=script&lang=js&"
export * from "./partner-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports